import React, { useState, Fragment } from 'react'
import IconButton from '@material-ui/core/IconButton'
import MuiMenu from '@material-ui/core/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import MenuItem from '@material-ui/core/MenuItem'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { dismissOutlierAlert } from '../../../../redux/actions'
import { injectIntl } from 'react-intl'
import history from '../../../../utilities/history'
const ITEM_HEIGHT = 48

const AlertOptions = ({ intl, alert, dismiss }) => {
	const [ anchorEl, setAnchorEl ] = useState(null)
	const open = Boolean(anchorEl)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const onDismiss = () => {
		dismiss(alert.id)
		handleClose()
	}

	const onReview = () => {
		history.push(`/cases/${alert.caseId}`)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const onEmailPatient = () => {
		if (alert && alert.patientEmail) {
			window.location.href = `mailto:${alert.patientEmail}`
			handleClose()
		}
	}

	return (
		<div data-testid="myalerts-outlier-alert-menu">
			<div>
				<IconButton
					data-testid="myalerts-outlier-alert-menu-button-more"
					aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
					<MoreVertIcon />
				</IconButton>
				<MuiMenu
					data-testid="myalerts-outlier-alert-menu-long"
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
						style: {
							maxHeight: ITEM_HEIGHT * 4.5,
							width: 200,
							backgroundColor: '#243041',
							color: '#fff'
						}
					}}
				>
					{/* <MenuItem onClick={onReview} id="1">
						{intl.formatMessage({ id: 'app.alerts.outlierReviewLabel' })}
					</MenuItem> */}
					<MenuItem data-testid="email-patient" onClick={onEmailPatient} id="2">
						{intl.formatMessage({ id: 'app.dashboard.emailPatient' })}
					</MenuItem>
					<MenuItem data-testid="dismiss" onClick={onDismiss} id="2">
						{intl.formatMessage({ id: 'app.alerts.outlierDismissLabel' })}
					</MenuItem>
				</MuiMenu>
			</div>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({
	dismiss: (id) => dispatch(dismissOutlierAlert(id))
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(AlertOptions)
